import { API_BASE_URL } from "../api/axiosClient";

/**
 * يحوّل مسار صورة نسبي جاي من الباك اند (زي "/uploads/xxx.png")
 * إلى رابط كامل يشير فعليًا لسيرفر الـ API (وليس سيرفر الفرونت اند).
 * لو الرابط أصلاً كامل (يبدأ بـ http)، بيرجعه زي ما هو من غير تغيير.
 */
export function resolveImageUrl(url) {
  if (!url) return null;
  return url.startsWith("http") ? url : `${API_BASE_URL}${url}`;
}